/* eslint-disable @typescript-eslint/no-explicit-any */
import { combineReducers, UnknownAction } from '@reduxjs/toolkit';
import { ILoginState } from 'interface/login/loginInfo';
import { IMessageState } from 'interface/message/messageInfo';
import { IDialogState } from 'interface/dialog/dialogInfo';
import { IMenuState } from 'interface/menu/menuInfo';
import { IProjectState } from 'interface/project/projectInfo';
import { IInspectionState } from 'interface/inspection/InspectionInfo';
import backdrop, { IBackdropState } from './backdrop/backdropSlice';
import login from './login/loginSlice';
import message from './message/messageSlice';
import dialog from './dialog/dialogSlice';
import menu from './menu/menuSlice';
import project from './project/projectSlice';
import inspection from './inspection/inspectionSlice';

export interface IRootReducer {
  backdrop: IBackdropState;
  login: ILoginState;
  message: IMessageState;
  dialog: IDialogState;
  menu: IMenuState;
  project: IProjectState;
  inspection: IInspectionState;
}
const appReducer = combineReducers({
  backdrop,
  login,
  message,
  dialog,
  menu,
  project,
  inspection,
});

export const rootReducer = (state: any, action: UnknownAction): IRootReducer => {
  if (action.type === 'login/logout' || action.type === 'login/reset') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;
